var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusNudge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 12.75a.725.725 0 01-.534-.216A.726.726 0 015.5 12c0-.213.072-.391.216-.534a.725.725 0 01.534-.216h11.5c.212 0 .39.072.534.216A.726.726 0 0118.5 12c0 .213-.072.391-.216.534a.726.726 0 01-.534.216H6.25z",
    fill: "currentColor"
  })));
}
SvgMinusNudge.displayName = 'MinusNudge';
export default SvgMinusNudge;